module.exports = __webpack_public_path__ + "static-portal/img/xzz-aqhb.249b7ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xzz-aqhb.jpg
// module id = tW+o
// module chunks = 4